import React from "react";
import { v4 as uuidv4 } from "uuid";

const UncheckedCircle: React.FC = () => {
  const svgUuid = uuidv4();

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={`uncheckedCircleComponentIconTitle-${svgUuid}`}
      role="img"
    >
      <title id={`uncheckedCircleComponentIconTitle-${svgUuid}`}>
        Empty Circle
      </title>
      <desc id={`uncheckedCircleComponentIconDesc-${svgUuid}`}>
        An outline of a circle.
      </desc>
      <path
        d="M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12Z"
        stroke="black"
      />
    </svg>
  );
};

export default UncheckedCircle;
